import $ from 'jquery';
import _ from 'underscore';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const getGlobalConfig = () => globalContext.require('component/config/index');
const getIsManagementDashboardEnabled = (getAppConfig = getGlobalConfig) => getAppConfig().get('Permissions').IsManagementDashboardEnabled;

const HiddenNewManagementDashboardColumns = ['OwnerId'];

export function isInManagementTab(gridType, getAppConfig) {
  const IsManagementDashboardEnabled = getIsManagementDashboardEnabled(getAppConfig);

  return gridType ? IsManagementDashboardEnabled && (gridType === 'budget' || gridType === 'management') : IsManagementDashboardEnabled;
}

export function appendNewManagementDashboardExtrasFilter(columns, getAppConfig) {
  return getIsManagementDashboardEnabled(getAppConfig) ? columns.concat(HiddenNewManagementDashboardColumns) : columns;
}

const ColumnPadding = 5;

const columnsWithDynamicWidth = [
  {
    cellContentClass: 'td.actions-cell ul',
    headerClass: 'th[data-name="Actions"] .grid-header-text',
    columnClass: 'col.col-Actions',
    gridClass: '.budgetGrid',
  },
  {
    cellContentClass: 'td.primary-contact-cell span',
    headerClass: 'th[data-name="PrimaryContact"] .column-header-container',
    columnClass: 'col.col-PrimaryContact',
    gridClass: '.budgetGrid',
  },
  {
    cellContentClass: 'td.time-zone-cell span',
    headerClass: 'th[data-name="AccountTimeZone"] .column-header-container',
    columnClass: 'col.col-AccountTimeZone',
    gridClass: '.budgetGrid',
  },
  {
    cellContentClass: 'td.payment-method-cell span',
    headerClass: 'th[data-name="PaymentMethod"] .column-header-container',
    columnClass: 'col.col-PaymentMethod',
    gridClass: '.budgetGrid',
  },
  {
    cellContentClass: '.bill-to-customer-cell span',
    headerClass: 'th[data-name="BillToCustomerName"] .column-header-container',
    columnClass: 'col.col-BillToCustomerName',
    gridClass: '.budgetGrid',
  },
  {
    cellContentClass: '.owners-accounts-cell span',
    headerClass: 'th[data-name="Owner"] .column-header-container',
    columnClass: 'col.col-Owner',
    gridClass: '.budgetGrid',
  },
];

const getMaxWidthOfAllCellContents = cellContents => _.chain(cellContents)
  .map(cell => Math.ceil(_.max([$(cell).width(), cell.scrollWidth])))
  .max()
  .value();

const buildStyleContent = ({ gridClass, columnClass, width }) => `.bingadsgrid${gridClass} table.table ${columnClass} { width: ${width}px; }`;

const getDynamicStyleDom = () => {
  const dynamicStyleDomId = 'dynamic-col-width';
  let dynamicStyleDom = $(`#${dynamicStyleDomId}`);

  if (!dynamicStyleDom.length) {
    dynamicStyleDom = $('<style/>', { id: dynamicStyleDomId, type: 'text/css' });
    dynamicStyleDom.appendTo('head');
  }

  return dynamicStyleDom;
};

/**
 * Ceiling by 10 instead of Math.ceil's by 1
 * @param {number} number the value to ceil
 * @returns {number} ceiled value
 */
const ceilByTen = number => Math.ceil(number / 10) * 10;

// using debouncing to reduce content jumping during multiple update calls
export const updateDynamicColumnWidth = _.debounce(() => {
  const dynamicStyleDom = getDynamicStyleDom();
  dynamicStyleDom.empty();

  window.requestAnimationFrame(() => {
    // Since management grid is set as fixed table layout, the column width cannot be set according to content
    // So this is a hack to resize the columns to fit the content to avoid overlap.
    const columnStyleToUpdate = [];

    _.each(columnsWithDynamicWidth, ({
      cellContentClass, headerClass, columnClass, gridClass,
    }) => {
      if ($(cellContentClass).length) {
        const actualWidth = Math.max(
          getMaxWidthOfAllCellContents($(cellContentClass)),
          $(headerClass).prop('scrollWidth')
        ) + (2 * ColumnPadding);
        // Ceiling by 10 to reduce the content jumping and also leave enough space on the right end
        const expectedWidth = ceilByTen(actualWidth);
        columnStyleToUpdate.push(buildStyleContent({ gridClass, columnClass, width: expectedWidth }));
      }
    });
    if (columnStyleToUpdate.length) {
      dynamicStyleDom.html(columnStyleToUpdate.join(' '));
    }
  });
}, 200);
